import React from "react";
import { MapPin } from "lucide-react";
import moment from "moment";
import { EventData } from "../interface/event.interface";
import { Link } from "react-router";

interface EventCardProps {
  item: EventData;
}

const EventCard: React.FC<EventCardProps> = ({ item }) => {
  const formattedDate = moment(item.startdate);
  const day = formattedDate.format("DD");
  const month = formattedDate.format("MMM");
  return (
    <div className="relative w-full min-w-sm overflow-hidden bg-lightBackground cursor-pointer text-text rounded-3xl bg-bgCard group">
      <Link to={`/event-detail/${item.id}`}>
        <div className="relative h-[180px] w-full overflow-hidden">
          {/* Image with zoom effect */}
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-300 group-hover:scale-110"
            style={{
              backgroundImage: `url(${item.image})`,
            }}
          ></div>

          {/* Date Badge */}
          <div className="absolute left-4 top-4 rounded-lg bg-bg px-3 py-1 flex flex-col items-center">
            <div className="text-sm font-medium">{day}</div>
            <div className="text-xs">{month}</div>
          </div>
        </div>
        {/* Content */}
        <div className="p-4">
          <h3 className="mb-2 text-base font-medium">{item.eventname}</h3>

          {/* Location */}
          <div className="mb-4 flex items-center gap-2 text-sm">
            <MapPin className="h-4 w-4" />
            <span className="line-clamp-1">{item.addressdetail}</span>
          </div>
          {item.join && item.join.length > 0 && (
            <div className="flex items-center gap-2">
              <span className="text-sm ">+{item.join.length} interested</span>
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};
export default EventCard;
